import { MyInstituteService } from './../../services/institute/myinstitute/my-institute.service';
import { State, Action, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { MyInstituteStateModel } from './my-institute-state-model';
import { AddMyInstitute, RemoveMyInstitute, SetMyAddedInstitute, UpdateMyInstitutesList } from './my-institute-actions';
import { tap } from 'rxjs';

@State<MyInstituteStateModel>({
  name: 'myinstitutes',
  defaults: {
    items: []
  }
})
@Injectable()
export class MyInstituteState {

  constructor(private myInstituteService: MyInstituteService) {
  }

  @Action(AddMyInstitute)
  addMyInstitute(ctx: StateContext<MyInstituteStateModel>, action: AddMyInstitute) {
    const state = ctx.getState();

    return this.myInstituteService.addMyInstitute(action.payload.item.id).pipe(
      tap(() => {
        ctx.setState({
          ...state,
          items: [...state.items, action.payload.item]
        });
      })
    );
  }

  @Action(UpdateMyInstitutesList)
  updateMyInstitutesList(ctx: StateContext<MyInstituteStateModel>, action: UpdateMyInstitutesList) {
    const state = ctx.getState();
    const existingIndex = state.items.findIndex(item => item.id === action.payload.id);
    let newItems;
    if (existingIndex !== -1) {
      newItems = [...state.items];
      newItems[existingIndex] = action.payload;
    } else {
      newItems = [...state.items, action.payload];
    }
    ctx.setState({
      ...state,
      items: newItems
    });
  }

  @Action(RemoveMyInstitute)
  removeMyInstitute(ctx: StateContext<MyInstituteStateModel>, action: RemoveMyInstitute) {
    const state = ctx.getState();
    // Call the service to remove the institute
    return this.myInstituteService.removeMyInstitute(action.payload.instituteId, action.payload.studentId).pipe(
      tap(() => {
        // Update the state only after the removal is confirmed
        const newItems = state.items.filter(item => item.id !== action.payload.instituteId);
        ctx.setState({
          ...state,
          items: newItems
        });
      })
    );
  }

  @Action(SetMyAddedInstitute)
  setMyInstitute(ctx: StateContext<MyInstituteStateModel>, action: SetMyAddedInstitute) {
    const state = ctx.getState();
    const newItems = action.payload.items;
    ctx.setState({
      ...state,
      items: newItems
    });
    return state;
  }
}